// extracted by mini-css-extract-plugin
module.exports = {"items":"FlipCards_items__3AhGt","item":"FlipCards_item__2R1oV","itemDivider":"FlipCards_itemDivider__2WOez","buttonsBlock":"FlipCards_buttonsBlock__1I3up"};